import React from 'react';
import { css } from '@emotion/react';
import { AiContainedIcon, gradientAnimationStyles } from '@frontend/styled-icons';
import { NakedButton, Truncated, Text } from '@frontend/design-system';

export interface AIRButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  trackingId?: string;
  iconOnly?: boolean;
}

export const AIRButton = ({ children = 'AI Receptionist', onClick, trackingId, iconOnly, ...rest }: AIRButtonProps) => {
  return (
    <NakedButton {...rest} trackingId={trackingId} css={styles.button} onClick={onClick}>
      <div className='button-content' css={styles.buttonContent}>
        <div css={[styles.iconContainer, !iconOnly && styles.iconBordered]}>
          <AiContainedIcon className='ai-icon' containerStyles={styles.aiIcon} iconName='aiweave-assistant' size={40} />
        </div>
        {!iconOnly && (
          <div
            style={{
              padding: '0 var(--fabric-space-padding-sm)',
              fontWeight: 'var(--fabric-font-weight-bold)',
              minWidth: 0,
              overflow: 'hidden',
            }}
          >
            {typeof children === 'string' ? (
              <Truncated as={Text} weight='bold'>
                {children}
              </Truncated>
            ) : (
              children
            )}
          </div>
        )}
      </div>
    </NakedButton>
  );
};

const styles = {
  button: css({
    background: `linear-gradient(var(--fabric-color-surface-default), var(--fabric-color-surface-default)) padding-box,
      linear-gradient(90deg, #1950A3 0%, #0D5D59 100%) border-box`,
    border: '1px solid transparent',
    borderRadius: 'var(--fabric-radius-sm)',
    boxShadow:
      '0px 1px 1px 0px var(--fabric-color-shadow-light-base) 0px 1px 3px 1px var(--fabric-color-shadow-light-base)',
    position: 'relative',
    overflow: 'hidden',
    maxWidth: '100%',
    minWidth: 0,

    // This is precise because of how we position the AiContainedIcon
    height: '42px',

    '&:hover, &:focus, &:focus-within': {
      '.button-content': {
        ...gradientAnimationStyles(),
      },

      '.ai-icon': {
        ...gradientAnimationStyles('#1950A3', '#0D5D59'),
        color: 'white',
      },
    },
  }),
  buttonContent: css`
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    min-width: 0;
    overflow: hidden;

    // This nests the rounded corners of the border better
    border-radius: 3px;
    height: 40px;
  `,
  iconContainer: css`
    background: linear-gradient(var(--fabric-color-surface-default), var(--fabric-color-surface-default)) padding-box,
      linear-gradient(90deg, #1950a3 0%, #0d5d59 100%) border-box;
  `,
  iconBordered: css`
    display: grid;
    border: 1px solid transparent;
    border-radius: 3px; // This nests the rounded corners of the border better
    position: relative;
    top: -1px;
    left: -1px;
  `,
  aiIcon: css`
    border-radius: 2px;
  `,
};
